import { useState, useEffect, useRef } from "react";
import { ClientSiteTabbed } from "./clientSiteTabbed"
import { useHistory } from 'react-router-dom';
import { ErrorModal } from "../../utilities/errorModal";
import Api from '../api/api';
import stringHelpers from "../../utilities/stringHelpers";
import { SuccessModal } from "../shared/successModal";
import Loader from "../shared/loader";

export default function ImportAllowList({ organisationId, token }) {
    const history = useHistory();
    const inputRef = useRef();
    const [tabActiveKey, setTabActiveKey] = useState("global");
    const [clients, setClients] = useState(null);
    const [site, setSite] = useState(null);
    const [sites, setSites] = useState();
    const [siteGroups, setSiteGroups] = useState(null);
    const [siteGroup, setSiteGroup] = useState("");
    const [formClientId, setFormClientId] = useState("");
    const [canSave, setCanSave] = useState(false);
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const allowListLandingUrl = `/organisation/${organisationId}/allow-list`

    const getClients = () => {
            Api.getClients(
                data => setClients(data),
                error => console.log(error),
                organisationId,
                token
            )
        }
    const getSites = (callback) => {

        Api.getSites(
            (data) => {
                setSites(data);
                if (callback) {
                    callback();
                }
            },
            (error) => console.log(error),
            organisationId,
            token
        )

    };

    const handleFileUploadChange = () => {
        if (inputRef.current && inputRef.current.files[0]) {
            const inputFile = inputRef.current.files[0];
            if (inputFile.name.toLowerCase().endsWith(".xlsx")) {
                if (inputFile) {
                    const formData = new FormData();
                    formData.append('File', inputFile);
                    setFile(formData);
                    setCanSave(true)
                }
            } else setError("Invalid file extension. File should be of type .xlsx")
        }
    }

    const submit = () => {
        setIsLoading(true)
        if (file) {
            if (!stringHelpers.isNullOrEmpty(formClientId)) {
                file.set("ClientId", formClientId)
            }
            if (!stringHelpers.isNullOrEmpty(siteGroup)) {
                file.set("SiteGroupId", siteGroup)
            }
            if (site !== null) {
                file.set("SiteId", site.id)
            }
        }
        
        Api.importAllowList(
            organisationId, file,
            data => {
                if (data.isError) {
                    setError(data.errorMessage)
                } else {
                    setSuccess(`Successfully imported ${data.length} entries`)
                }
                setIsLoading(false)
            },
            error => {
                setIsLoading(false)
                setError(error.message)
            },
            token
        )
    }
    const handleTabChange = (e) => {
        setTabActiveKey(e);
        setSite(null);
        setSiteGroup("");

        if (e === "client" && clients.length === 1) {
            setFormClientId(clients[0].id);
        } else {
            setFormClientId("");
        }
    }

    useEffect(() => {
        getSites();
        getClients();
    }, []);

    useEffect(() => {
        if (site && site !== null) {
            Api.getSiteGroupsBySiteId(
                organisationId, site.id, 
                result => setSiteGroups(result),
                error => console.log(error),
                token
            )
        }
    }, [site]);

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-3">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h5 className="mb-0">Import Allow List</h5>
                                <button className='btn btn-secondary'>
                                    <a href="/assets/files/APT Allow List Template.xlsx" className="d-flex align-items-center text-white" download>
                                        Template<i className="fas fa-download ml-2" />
                                    </a>
                                </button>
                            </div>
                            <div className="card-body bg-light border-top details-container">
                                {isLoading
                                ? <Loader />
                                : <>
                                    <h6 className="mb-3 fs-1">File Details</h6>
                                    <div className="row">
                                        <div className="col-md-3 col-12">
                                            <p className="font-weight-semi-bold mt-1">Upload File</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div class="form-group">
                                                <input ref={ inputRef } onChange={ () => handleFileUploadChange() } class="form-control-file" type="file" accept=".xlsx" />
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="border-dashed border-bottom-0"></hr>

                                    <ClientSiteTabbed
                                        onTabChange={ e => handleTabChange(e) }
                                        clients={ clients }
                                        client={ formClientId }
                                        setClient={ setFormClientId }
                                        sites={ sites }
                                        site={ site }
                                        setSite={ setSite }
                                        siteGroup={ siteGroup }
                                        siteGroups={ siteGroups }
                                        setSiteGroup={ setSiteGroup }
                                        anprCameras={ null }
                                        anprCameraId={ null }
                                        roi={ null }
                                        isClientOrClientManager={ false }
                                        activeKey={tabActiveKey}
                                    />
                                </>}
                            </div>
                            <div className="card-footer border-top ">
                                <div className="row client-edit-buttons">
                                    <div className="col-12 col-sm-auto ml-auto pl-0">
                                        <div id="dashboard-actions">
                                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => history.push(allowListLandingUrl) }>
                                                <i className="fas fa-times"></i> Cancel</button>
                                            <button type="button" className="btn btn-success btn-sm ml-2" disabled={ !canSave } onClick={ () => submit() }>
                                                <i className="fas fa-check"></i> Confirm</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!stringHelpers.isNullOrEmpty(error) && 
                <ErrorModal
                    message={ error }
                    onHide={ () => setError(null) }
                />}
                {!stringHelpers.isNullOrEmpty(success) && 
                <SuccessModal
                    message={ success }
                    onHide={ () => {
                        setSuccess(null)
                        history.push(allowListLandingUrl)
                    } }
                />}
            </div>
        </>
    )
}